export enum LearningSectionEnum {
  Target = 'Target',
  Assessment = 'Assessment',
  Progress = 'Progress',
  Observation = 'Observation',
  Document = 'Document'
}
